module.exports = __webpack_public_path__ + "7af66794.svg";